import axios from 'axios'
const API_V1_URL = process.env.API_V1_URL

export default {
  getCurrencies(offset, limit) {
    // return axios.get(API_V1_URL + '/prices/currencies/?limit=40000')
    //   .then(res => res.data)
    //   .catch(errObj => Promise.reject(errObj.response.data.error))
    var query = [
      ['offset', offset],
      ['limit', limit],
    ].map(pair => pair.join('=')).join('&')

    return axios.get(API_V1_URL + '/prices/currencies?' + query)
      .then(res => {
        return {
          currencies: res.data,
          total: res.count,
        }
      })
  },
  getCurrenciesTotal() {
    return axios.get(API_V1_URL + '/prices/currencies')
      .then(res => { return res.count })
      .catch(errObj => Promise.reject(errObj.response.data.error))
  },
  deleteCurrency(id) {
    return axios.delete(API_V1_URL + '/prices/' + id)
  },
}



// WEBPACK FOOTER //
// ./src/-service-app/services/currencyService.js